import { Lightning } from "@phosphor-icons/react";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1643142314913-0cf633d9bbb5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjYXIlMjBkZWFsZXJzaGlwJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzgxNTA5OTcxfDA&ixlib=rb-4.1.0&q=85";

export default function LoginBrandPanel() {
  return (
    <div className="hidden lg:flex w-1/2 relative bg-ink overflow-hidden">
      <img
        src={HERO_IMAGE}
        alt="dealership"
        className="absolute inset-0 w-full h-full object-cover opacity-60"
      />
      <div className="absolute inset-0 bg-gradient-to-br from-ink/40 via-ink/20 to-transparent" />
      <div className="relative z-10 flex flex-col justify-between p-12 text-white w-full">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-white flex items-center justify-center">
            <Lightning size={18} weight="fill" className="text-ink" />
          </div>
          <div className="font-display font-bold tracking-tight text-lg">
            MOTORLEDGER
          </div>
        </div>
        <div>
          <div className="font-mono text-[11px] tracking-[0.3em] uppercase opacity-80 mb-3">
            Dealer Operating System
          </div>
          <h2 className="font-display text-5xl font-bold leading-[0.95] tracking-tight max-w-md">
            Inventory, sales & customers. One ledger.
          </h2>
          <p className="text-sm opacity-80 max-w-sm mt-4">
            Operate your dealership floor with a single source of truth across
            cars, bikes, and trucks.
          </p>
        </div>
        <div className="font-mono text-[10px] tracking-widest uppercase opacity-60">
          // SHIFT START — {new Date().toLocaleDateString()}
        </div>
      </div>
    </div>
  );
}
